import { render, staticRenderFns } from "./tag-form.vue?vue&type=template&id=cb76aab2&scoped=true"
import script from "./tag-form.vue?vue&type=script&setup=true&lang=js"
export * from "./tag-form.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb76aab2",
  null
  
)

export default component.exports